import React from "react";
import heartGif from '../../assets/red-heart-bumping.gif'

const CustomHeading = ({
    text,
    textColor = "#121212",
    textSize = "50px",
    margin = "m-0",
    padding = "p-0",
    leading="63px",
    fontStyle = "font-Wonderbar",
    textAlign = "left", // Default text alignment
    heartMarginLeft = "10px",
    heartMarginRight,
    rotateHeart="rotate-0",
    heartPosition = "relative", // Default heart position
    showHeart = false,
    heartTop = "5px", // Default heart top
    customImg,
    spanText,
    spanTextColor="#d31c4f",
    marginTop,
    marginBottom="2%",
    smTextSize="40px",
    heartHeight="48px",
    heartWidth="48px",
    mobileHeartHeight="36px",
    mobileHeartWidth="36px",
    thirdText,
    thirdTextColor="#121212",
    secondFontStyle="font-Wonderbar"
  }) => {
    return (
      <h2
        style={{
          fontSize:window.innerWidth < 450 ? smTextSize : textSize,
          lineHeight:window.innerWidth < 450 ? "48px" : leading,
          marginTop:marginTop,
          color:textColor,   
          textAlign: textAlign, // Always use the passed textAlign or default to 'left'
        }}
        className={`relative ${margin} ${padding} ${fontStyle}`}
      >
        {text}
        {
          spanText && <span style={{
            color:spanTextColor
          }} className={`inline ${secondFontStyle}`} dangerouslySetInnerHTML={{ __html: spanText }}></span>
        }
        {
          thirdText && <span style={{
            color:thirdTextColor
          }} className="inline">{thirdText}</span>
        }
        {(showHeart || customImg) && (
          <img
            src={customImg ? customImg :heartGif}
            style={{
              marginLeft: heartMarginLeft,
              height:window.innerWidth < 450 ? mobileHeartHeight:heartHeight,
              width:window.innerWidth < 450 ? mobileHeartWidth:heartWidth, 
              marginBottom:marginBottom,
              position: heartPosition, // Use the passed heartPosition or default to 'relative'
              top: heartTop, // Use the passed heartTop or default to '5px'
            }}
            alt="💚"
            className={`inline my-auto ${rotateHeart}`}
          />
        )}
      </h2>
    );
  };
  

  export default CustomHeading